export const SliderInput = ({ field, value, onChange }) => {
  const fill = ((value - field.min) / (field.max - field.min)) * 100;
  return (
    <div className="space-y-2.5">
      <div className="flex items-baseline justify-between gap-3">
        <label htmlFor={field.key} className="text-sm font-medium text-slate-600">
          {field.label}
        </label>
        <span data-testid={`${field.testid}-value`} className="font-mono text-sm font-semibold tabular-nums text-slate-900">
          {field.format(value)}
        </span>
      </div>
      <input
        id={field.key}
        data-testid={field.testid}
        type="range"
        min={field.min}
        max={field.max}
        step={field.step}
        value={value}
        onChange={(e) => onChange(field.key, parseFloat(e.target.value))}
        className="inmo-range"
        style={{ "--fill": `${fill}%` }}
      />
    </div>
  );
};
